import { HStack } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
	useProjectDetails,
	useSharedState,
} from '../../../../../@xmcloud/hooks';
import { IS_SM_SCREEN } from '../../../../../@xmcloud/hooks/context/useSharedState';
import { pageSize } from '../../../../../@xmcloud/utils/constants';
import { IGetEnvironmentResponseV2 } from '../../../../models/environmentModel';
import { useGetProjectEnvironmentsList } from '../../../../services/projects';
import {
	Footer,
	LoadingSkeleton,
	RenderPlaceholder,
	Table,
	XMCSButton,
} from '../../../../shared-components';
import CreateCombinedEnvironment from '../../../../stale-components/CreateCombinedEnvironment';
import { useEnvironmentsTableColumns } from '../../columns/environments';
import { DeleteEnvironment } from '../../components/DeleteEnvironment';

const headers = ['Name', 'ID', 'Date created', ''];

export const EnvironmentsPageLegacy: React.FC = () => {
	const { projectId } = useParams<{
		projectId: string;
	}>();
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const { state: isSmScreen } = useSharedState(IS_SM_SCREEN, false);

	const { data, isLoading } = useGetProjectEnvironmentsList({
		projectId: projectId!,
	});
	const { project } = useProjectDetails(projectId!);

	const environments = data?.data || [];

	const {
		columns,
		editModal,
		setEditModal,
		environmentRef,
	}: {
		columns: ColumnDef<IGetEnvironmentResponseV2, any>[];
		editModal: boolean;
		setEditModal: React.Dispatch<React.SetStateAction<boolean>>;
		environmentRef: React.MutableRefObject<IGetEnvironmentResponseV2>;
	} = useEnvironmentsTableColumns(undefined, project?.isLocked);

	if (isLoading) {
		return <LoadingSkeleton amount={pageSize + 1} />;
	}

	return (
		<>
			<HStack justify="flex-end" py={isSmScreen ? 3 : 5}>
				{editModal && (
					<DeleteEnvironment
						{...{
							openModal: editModal,
							setOpenModal: setEditModal,
							environmentDetails: environmentRef.current,
						}}
					/>
				)}
				{!isSmScreen && (
					<XMCSButton
						{...{
							text: 'Create environment',
							onClick: () => setOpenCreateModal(true),
						}}
					/>
				)}
			</HStack>
			{environments.length === 0 ? (
				<RenderPlaceholder item="environments" />
			) : (
				<Table
					{...{
						columns: columns,
						tableData: environments,
						dataTestId: 'environments-table',
						showPagination: environments.length > pageSize,
						headers,
					}}
				/>
			)}
			{!!isSmScreen && (
				<Footer>
					<XMCSButton
						text="Create environment"
						onClick={() => setOpenCreateModal(true)}
					/>
				</Footer>
			)}
			{openCreateModal && (
				<CreateCombinedEnvironment
					openModal={openCreateModal}
					setOpenModal={setOpenCreateModal}
				/>
			)}
		</>
	);
};
